<template>
  <li :class="{ opened: opened }">
    <strong>{{ question }} <Plus class="icon" /></strong>
    <p>{{ answer }}</p>
  </li>
</template>
<script>
import Plus from '@/assets/images/common/icons/plus.svg?inline';

export default {
  name: 'FaqItem',
  components: {
    Plus,
  },
  props: {
    question: {
      type: String,
      required: true,
    },
    answer: {
      type: String,
      required: true,
    },
    opened: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style lang="stylus" scoped>
  // --bgColor: var(--main-color);
  // --textColor: var(--text-color);
  // --accentColor: var(--text-color);
  li {
    width: 100%;
    font-size: 15px;
    text-align: left;
    color: var(--textColor, var(--inverted-text-color));
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    // padding: 0 0 20px;
    border-bottom: 1px solid var(--textColor, var(--inverted-text-color));
    position: relative;
    gap: 20px;
    pointer-events: auto;
    cursor: pointer;

    &:last-child {
      border: none;
    }

    strong {
      display: flex;
      align-items: center;
      justify-content: space-between;
      text-align: left;
      width: 100%;

      & .icon {
        display: block;
        width: 40px;
        height: 40px;
        border: 1px solid var(--accentColor, var(--inverted-text-color));
        border-radius: 50%;
        padding: 10px;
        transition: all 0.3s ease;
        * {
          stroke: var(--accentColor, var(--inverted-text-color));
        }
      }
    }

    p {
      height: 0;
      overflow: hidden;
      interpolate-size: allow-keywords;
      transition: all 0.3s ease;
      transition-behavior: allow-discrete;
      margin: 0;
    }

    &.opened {
      & .icon {
        transform: rotate(45deg);
        background-color: var(--accentColor, var(--main-color));
        * {
          stroke: var(--bgColor, var(--white-color));
        }
      }
      p {
        height: auto;
        padding-bottom: 20px;
      }

      &:hover {
        .icon {
          transform: scale(1.1) rotate(0deg);
        }
      }
    }

    &:hover {

      .icon {
        background-color: var(--accentColor, var(--main-color));
        * {
          stroke: var(--bgColor, var(--white-color));
        }
      }
    }
  }
</style>
